<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import { numeric, required } from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import { pagingModel } from "@/models/core/pagingModel";
import DatePicker from "vue2-datepicker";
import Treeselect from "@riophae/vue-treeselect";
import { tinTucModel } from "@/models/profession/tinTuc/tinTucModel";
import { handleApiResponse } from "@/utils/api/apiResponseHandler";
import { STATUS_CODES } from "@/utils/api/apiConstants";
import ModalPreviewTinTuc from "@/components/modalPreviewNews.vue";
import VueMultiselect from "vue-multiselect";

import {
  ButtonCore,
  ZoomableImage,
  SearchResetButtons,
  ActionButtons,
} from "@/components/widgets";

import { formatDate } from "@/utils/time/dateUtils.js";

export default {
  page: {
    title: "Danh sách bài đăng",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,

    PageHeader,
    ModalPreviewTinTuc,
    VueMultiselect,
    SearchResetButtons,
    ButtonCore,
    ActionButtons,
  },
  data() {
    return {
      title: "Danh sách bài đăng",
      items: [
        {
          text: "Danh sách bài đăng",
          href: "/danh-sach",
        },
        {
          text: "Danh sách",
          active: true,
        },
      ],
      list: [],
      fields: [
        {
          key: "approve",
          label: "",
          class: "td-content",
          thClass: "hidden-sortable align-items-center vertical-align-center" ,
          tdClass: "text-center",
          thStyle: "width: 40px",
        },
        // {
        //   key: "STT",
        //   label: "STT",
        //   class: "td-stt",
        //   sortable: false,
        //   thClass: "hidden-sortable",
        // },
        {
          key: "name",
          label: "Nội dung",
          class: "td-username",
          sortable: false,
          thStyle: "text-align:left ",
          thClass: "hidden-sortable text-uppercase",
        },
        {
          key: "nameAuthor",
          label: "Tên người đăng",
          class: "td-content",
          sortable: false,
          thStyle: { align: "middle", width: "150px" },
          tdStyle: { align: "center" },
          thClass: "hidden-sortable text-center text-uppercase",
          tdClass: "text-center",
        },

        {
          key: "createdAt",
          label: "Ngày đăng",
          class: "td-content",
          sortable: false,
          thClass: "hidden-sortable text-center text-uppercase",
          tdClass: "text-center",
          thStyle: { width: "90px", minWidth: "60px" },
        },
        {
          key: "isPublish",
          label: "Thao tác",
          class: "td-content",
          sortable: false,
          thClass: "hidden-sortable text-center text-uppercase",
          tdClass: "text-center",
          thStyle: { width: "100px", minWidth: "80px" },
        },
        {
          key: "process",
          label: "Xử lý",
          class: "td-XuLy text-center",
          sortable: false,
          thClass: "hidden-sortable text-uppercase",
          thStyle: { width: "70px", minWidth: "60px" },
        },
      ],

      actionDefinitions: [
        {
          type: "view", // Sự kiện @view sẽ được emit
          text: "Xem",
          // iconClass: "fas fa-eye",
          variantClass: "btn-search-core",
          needsId: false, // Truyền cả item
          customStyle: {
            height: "30px",
            alignItems: "center",
          },
          // Tùy chọn: shouldShow: (item) => item.status === 'published'
        },
        // {
        //   type: "edit",
        //   text: "Sửa",
        //   iconClass: "fas fa-pencil-alt",
        //   variantClass: "btn-edit-core",
        //   isRouterLink: true, // Đây là nút router-link
        //   basePath: "/danh-sach-tin-tuc/chi-tiet", // Path base cho router
        // },
        {
          type: "delete",
          text: "Xóa",
          // iconClass: "fas fa-trash-alt",
          variantClass: "btn-deleteOutline-core",
          needsId: true, // Chỉ truyền item._id
          customStyle: {
            height: "30px",
          },
        },
        // {
        //   type: "approve",
        //   text: "Duyệt",
        //   iconClass: "fas fa-check",
        //   variantClass: "btn-accept-core",
        //   isDisable: false,
        //   shouldShow: (item) => item.status === "pending", // Chỉ hiện khi trạng thái là pending
        // },
      ],

      formatDate: formatDate,

      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      showModal: false,
      showDeleteModal: false,
      submitted: false,
      sortBy: "age",
      filter: null,
      sortDesc: false,
      filterOn: [],
      numberOfElement: 1,
      totalRows: 1,
      model: tinTucModel.baseJson(),
      listCoQuan: [],
      listRole: [],
      pagination: pagingModel.baseJson(),
      itemFilter: {
        content: null,
        isPublic: null,
        commonShort: null,
      },

      listCommon: [],
      // NEW: Các lựa chọn cho filter Trạng thái Xuất bản
      statusOptions: [
        { value: null, text: "Tất cả" },
        { value: true, text: "Xuất bản" },
        { value: false, text: "Không xuất bản" },
      ],

      treeView: [],

      showModalApproveAll: false,
      listApprove: [],
      showPreview: false,

      tinTucSelected: null,
    };
  },

  created() {
    //   this.GetPagingParam();
    //    this.GetListParent();
    // this.getData();
  },
  computed: {
    selectableItems() {
      // Đảm bảo list (từ myProvider) đã được cập nhật
      return this.list.filter((x) => x);
    },

    isAllSelected() {
      // Logic đúng: Kiểm tra mảng không rỗng VÀ độ dài bằng số item trên trang
      return (
        this.listApprove.length > 0 &&
        this.listApprove.length === this.selectableItems.length
      );
    },
    currentPostIndex() {
      if (!this.tinTucSelected) return -1;
      return this.list.findIndex(item => item._id === this.tinTucSelected._id);
    },

    // NEW: Kiểm tra nút 'Tin trước' có bị disabled không
    isPreviousDisabled() {
      return this.currentPostIndex <= 0;
    },

    // NEW: Kiểm tra nút 'Tin sau' có bị disabled không
    isNextDisabled() {
      return this.currentPostIndex === this.list.length - 1;
    },
  },

  methods: {
    // NEW: Vị trí của bài viết đang được chọn trong list hiện tại
    // NEW: Hàm chuyển sang bài viết trước
    previousPost() {
      if (!this.isPreviousDisabled) {
        const newIndex = this.currentPostIndex - 1;
        this.tinTucSelected = this.list[newIndex];
      }
    },

    // NEW: Hàm chuyển sang bài viết sau
    nextPost() {
      if (!this.isNextDisabled) {
        const newIndex = this.currentPostIndex + 1;
        this.tinTucSelected = this.list[newIndex];
      }
    },
    // toggle chọn từng item
    toggleApprove(item) {
      const id = item._id;

      if (this.listApprove.includes(id)) {
        // CÁCH MỚI: Dùng filter và gán lại mảng mới
        this.listApprove = this.listApprove.filter((x) => x !== id);
      } else {
        // CÁCH MỚI: Tạo mảng mới bằng cách spread và thêm ID
        this.listApprove = [...this.listApprove, id];
      }
    },

    // chọn tất cả / bỏ chọn tất cả
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.listApprove = [];
      } else {
        // chọn tất cả: Gán mảng mới
        this.listApprove = this.selectableItems.map((x) => x._id);
      }

      // QUAN TRỌNG: Gọi refresh trong nextTick để đảm bảo Vue đã cập nhật listApprove xong
      this.$nextTick(() => {
        if (this.$refs.tblList && this.$refs.tblList.refresh) {
          this.$refs.tblList.refresh();
        }
      });
    },

    normalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },

    async getData() {
      let params = {
        start: this.currentPage,
        limit: this.perPage,
        content: this.itemFilter.content,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        isAdmin: true,
        isPublic: this.itemFilter.isPublic?.value ?? null,
      };
      await this.$store
        .dispatch("profession/tinTuc/tinTucStore/getPagingParams", params)
        .then((res) => {
          if (
            res &&
            res.data &&
            STATUS_CODES.SUCCESS_VALUES.includes(res.code)
          ) {
            this.list = res.data.data;
            this.totalRows = res.data.totalRows;
          } else {
            this.list = [];
            this.totalRows = 0;
            // this.$store.dispatch("snackBarStore/addNotify", res);
            this.$store.dispatch("snackBarStore/addNotify", {
              data: {
                code: res.code,
                message: res.message,
              },
            });
          }
        })
        .catch((error) => {
          console.error("Lỗi khi tải dữ liệu danh mục:", error);
          this.list = [];
          this.totalRows = 0;
          // this.$store.dispatch("snackBarStore/addNotify", {
          //   code: "ERROR",
          //   message: "Không thể tải dữ liệu danh mục.",
          // });
          this.$store.dispatch("snackBarStore/addNotify", {
            data: {
              code: -1,
              message: "Không thể tải dữ liệu danh mục.",
            },
          });
        });
    },

    async getListRole() {
      await this.$store.dispatch("unitRoleStore/getAll").then((res) => {
        this.listRole = res.data || [];
      });
    },
    async handleDelete() {
      if (this.model._id != 0 && this.model._id != null && this.model._id) {
        await this.$store
          .dispatch("profession/tinTuc/tinTucStore/delete", {
            _id: this.model._id,
          })
          .then((res) => {
            if (res.code === 0) {
              this.fnGetList();
              this.showDeleteModal = false;
            }
            var a = {
              message: res.message,
              code: res.code,
            };
            // console.log("LOG A : " ,a)
            this.$store.dispatch("snackBarStore/addNotify", {
              data: {
                code: res.code,
                message: res.message,
              },
            });
          });
      }
    },
    openPreview(item) {
      this.tinTucSelected = item;
      this.showPreview = true;
    },

    handleShowApproveAllModal() {
      if (this.listApprove.length > 0) {
        this.showModalApproveAll = true;
      } else {
        this.$store.dispatch("snackBarStore/addNotify", {
          data: {
            code: -1,
            message: "Vui lòng chọn tin tức",
          },
        });
      }
    },

    /**
     * HÀM XỬ LÝ DUYỆT/BỎ DUYỆT (Đơn lẻ HOẶC Hàng loạt)
     * @param {Object | null} item - Đối tượng tin tức (null nếu là hàng loạt)
     * @param {boolean} isBoDuyet - Trạng thái mong muốn (true nếu là Bỏ duyệt)
     */
    async handleApproveTinTuc(item = null, isBoDuyet) {
      console.log("Bool isBoDuyet: ", isBoDuyet);

      let listIdToApprove = [];
      let isMassAction = item === null;

      if (isMassAction) {
        // TRƯỜNG HỢP HÀNG LOẠT (TỪ NÚT XUẤT BẢN TẤT CẢ)
        listIdToApprove = this.listApprove;
        isBoDuyet = false; // Luôn là Duyệt khi gọi từ nút Xuất bản tất cả

        if (listIdToApprove.length === 0) {
          return;
        }
      } else {
        // TRƯỜNG HỢP ĐƠN LẺ (TỪ NÚT TRONG BẢNG HOẶC MODAL PREVIEW)
        listIdToApprove = [item._id];

        // Kiểm tra logic: Bỏ duyệt chỉ được 1 bài/lần, Duyệt có thể là 1 bài (từ bảng)
        // Logic của bạn đã đơn giản hóa ở đây: Luôn áp dụng hành động Duyệt/Bỏ duyệt cho ID đơn lẻ
      }

      console.info(
        `Thao tác: ${isBoDuyet ? "Bỏ duyệt" : "Duyệt"} ${
          listIdToApprove.length
        } bài viết.`,
        "ID: ",
        listIdToApprove
      );

      const param = {
        _id: listIdToApprove,
      };

      try {
        let actionPromise;
        if (isBoDuyet) {
          console.info("Bỏ duyệt");

          // Bỏ duyệt (Dùng cho hành động Bỏ duyệt đơn lẻ)
          actionPromise = this.$store.dispatch(
            "profession/tinTuc/tinTucStore/boDuyetBaiViet",
            param
          );
        } else {
          console.info("Duyệt bài viết");
          // Duyệt (Dùng cho hành động Duyệt đơn lẻ HOẶC Duyệt hàng loạt)
          actionPromise = this.$store.dispatch(
            "profession/tinTuc/tinTucStore/duyetBaiViet",
            param
          );
        }

        const res = await actionPromise;

        if (res.code === 0) {
          this.fnGetList(); // Gọi hàm tải lại dữ liệu (getData() cần được định nghĩa)

          // Xử lý đóng modal nếu cần
          if (this.showModalApproveAll) this.showModalApproveAll = false;
          if (this.showPreview) this.showPreview = false;

          // Xóa khỏi listApprove sau khi thành công (Chỉ xóa nếu là hành động hàng loạt)
          if (isMassAction) {
            this.listApprove = [];
          }

          this.$store.dispatch("snackBarStore/addNotify", {
            data: {
              code: 0,
              message: `Đã ${isBoDuyet ? "bỏ duyệt" : "duyệt"} ${
                listIdToApprove.length
              } bài viết thành công!`,
            },
          });
        } else {
          this.$store.dispatch("snackBarStore/addNotify", {
            data: {
              code: res.code,
              message: res.message,
            },
          });
        }
      } catch (err) {
        console.error("Lỗi khi duyệt bài viết: ", err);
        this.$store.dispatch("snackBarStore/addNotify", {
          data: {
            code: -1,
            message: "Đã có lỗi khi duyệt bài viết",
          },
        });
      }
    },

    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.itemFilter.content,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        isAdmin: true,
        isPublic: this.itemFilter.isPublic?.value ?? null,
      };

      this.loading = true;
      try {
        let promise = this.$store.dispatch(
          "profession/tinTuc/tinTucStore/getPagingParams",
          params
        );
        return promise.then((resp) => {
          if (
            resp &&
            resp.data &&
            STATUS_CODES.SUCCESS_VALUES.includes(resp.code)
          ) {
            let items = resp.data.data;
            this.totalRows = resp.data.totalRows;
            this.numberOfElement = resp.data.data.length;
            this.loading = false;
            this.list = items;
            return items || [];
          } else {
            this.list = [];
            this.totalRows = 0;
            this.$store.dispatch("snackBarStore/addNotify", {
              data: {
                code: resp.code,
                message: resp.message,
              },
            });
            return [];
          }
        });
      } catch (err) {
        console.error("Lỗi khi tải dữ liệu: ", err);
        this.$store.dispatch("snackBarStore/addNotify", {
          data: {
            code: -1,
            message: "Không thể tải dữ liệu.",
          },
        });
      } finally {
        this.loading = false;
      }
    },

    handleShowDeleteModal(id) {
      this.model._id = id;
      this.showDeleteModal = true;
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (this.model._id != 0 && this.model._id != null && this.model._id) {
          console.log("LOG USER UPDATE NE : ", this.model);
          // Update model
          await this.$store
            .dispatch("profession/tinTuc/tinTucStore/update", this.model)
            .then((res) => {
              if (res.code === 0) {
                this.showModal = false;
                this.$refs.tblList.refresh();
              }
              this.$store.dispatch("snackBarStore/addNotify", {
                data: {
                  code: res.code,
                  message: res.message,
                },
              });
            });
        } else {
          // Create model
          console.log("LOG USER CREATE NE : ", this.model);
          await this.$store
            .dispatch("profession/tinTuc/tinTucStore/create", this.model)
            .then((res) => {
              if (res.code === 0) {
                this.fnGetList();
                this.showModal = false;
                this.model = {};
              }
              this.$store.dispatch("snackBarStore/addNotify", {
                data: {
                  code: res.code,
                  message: res.message,
                },
              });
            });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    async handleUpdate(id) {
      await this.$store
        .dispatch("contentStore/getById", { _id: id })
        .then((res) => {
          if (res.code === 0) {
            console.log(res);
            this.model = tinTucModel.toJson(res.data);
            this.showModal = true;
          } else {
            this.$store.dispatch("snackBarStore/addNotify", {
              data: {
                code: res.code,
                message: res.message,
              },
            });
          }
        });
    },
    handleSearch() {
      // this.currentPage = 1;
      // this.getData();
      this.$refs.tblList.refresh();
    },
    handleClear() {
      this.itemFilter = {
        content: null,
        isPublic: null,
      };
      this.currentPage = 1;
    },

    async fnGetList() {
      this.$refs.tblList?.refresh();
    },
  },
  mounted() {
    // this.getListRole();
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        // addCoQuanToModel()
        // this.saveValueToLocalStorage()
      },
    },

    showModal(status) {
      if (status == false) this.model = tinTucModel.baseJson();
    },

    // model() {
    //   return this.model;
    // },
    showDeleteModal(val) {
      if (val == false) {
        this.model.id = null;
      }
    },
    showModalApproveAll(val) {
      if (val == false) {
        this.listApprove = [];
      }
    },
  },
  filters: {
    // Filter cắt ngắn chuỗi
    truncate(value, length) {
      if (value.length > length) {
        return value.substring(0, length) + "...";
      }
      return value;
    },

    // Filter định dạng số (cần cài đặt thư viện format nếu số lớn)
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row d-flex align-items-center justify-content-center">
              <div class="mb-3 col-sm-12 col-lg-6">
                <label class="text-left mb-0">Nội dung</label>
                <input
                  v-model="itemFilter.content"
                  type="text"
                  name="untyped-input"
                  class="form-control"
                  placeholder="Tìm kiếm theo tiêu đề"
                />
              </div>

              <div class="mb-3 col-sm-12 col-lg-6">
                <label class="text-left mb-0">Trạng thái duyệt</label>

                <VueMultiselect
                  v-model="itemFilter.isPublic"
                  :options="statusOptions"
                  label="text"
                  track-by="value"
                  placeholder="Tất cả trạng thái"
                />
              </div>
            </div>
            <div class="col-12 d-flex justify-content-center">
              <div
                class="row d-flex col-lg-12 align-items-center justify-content-center"
              >
                <SearchResetButtons
                  :handleSearch="handleSearch"
                  :handleClear="handleClear"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <!-- KHU VỰC ĐIỀU KHIỂN HÀNG NGANG (Pagination + Mass Actions) -->
                <div class="row mt-4 mb-2">
                  <!-- Cột 1: Hiển thị số lượng dòng (col-md-4) -->
                  <div class="col-sm-12 col-md-4">
                    <div
                      class="col-sm-12 d-flex justify-content-left align-items-center"
                    >
                      <div
                        id="tickets-table_length"
                        class="dataTables_length m-1"
                        style="
                          display: flex;
                          justify-content: left;
                          align-items: center;
                        "
                      >
                        <div class="me-1">Hiển thị</div>
                        <b-form-select
                          class="form-select form-select-sm"
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                          style="width: 70px"
                        ></b-form-select
                        >&nbsp;
                        <div style="width: 100px">dòng</div>
                      </div>
                    </div>
                  </div>

                  <!-- Cột 2: Các nút hành động hàng loạt (col-md-8) -->
                  <!-- Sử dụng d-flex justify-content-end để đẩy các nút sang phải -->
                  <div
                    class="col-sm-12 col-md-8 d-flex justify-content-end align-items-center news-control-bar-col"
                  >
                    <!-- Nút "Chọn/Bỏ chọn tất cả" (Hoạt động như Toggle Checkbox) -->

                    <!-- Khu vực hiển thị số lượng và nút Xử lý hàng loạt -->
                    <div class="d-flex align-items-center">
                      <!-- Badge số lượng đã chọn -->
                      <span class="news-badge-count me-3">
                        Đã chọn: {{ listApprove.length }}
                      </span>

                      <!-- Nút "Xuất bản tất cả" -->
                      <button
                        type="button"
                        class="news-btn-action-custom news-btn-publish-all"
                        v-on:click="handleShowApproveAllModal"
                      >
                        <i class="fas fa-upload"></i> Xuất bản tất cả
                      </button>
                    </div>
                  </div>
                </div>
                <div class="table-responsive mb-0">
                  <b-table
                    class="datatables table-admin"
                    :items="myProvider"
                    :fields="fields"
                    striped
                    bordered
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    ref="tblList"
                    primary-key="_id"
                  >
                    <template v-slot:head(approve)="">
                      <input
                        type="checkbox"
                        :key="'approveAll'"
                        :checked="isAllSelected"
                        @change="toggleSelectAll"
                      />
                    </template>

                    <!-- <template v-slot:cell(approve)="data">
                      <div
                        class="d-flex justify-content-center vertical-align-center"
                      >
                        <input
                          type="checkbox"
                          :key="'approve-' + data.item._id"
                          :checked="listApprove.includes(data.item._id)"
                          @change="toggleApprove(data.item)"
                        />
                      </div>
                    </template> -->
                    <template v-slot:cell(approve)="data">
                      <div
                        :key="
                          'check-' + data.item._id + '-' + listApprove.length
                        "
                        class="d-flex justify-content-center vertical-align-center"
                      >
                        <input
                          type="checkbox"
                          :checked="listApprove.includes(data.item._id)"
                          @change="toggleApprove(data.item)"
                        />
                      </div>
                    </template>
                    <template v-slot:cell(name)="data">
                      <div
                        v-if="data.item.describe"
                        class="table-limit-text-lines"
                      >
                        {{ data.item.describe }}
                      </div>
                    </template>

                    <!-- <template v-slot:cell(menu)="data">
                      <span v-if="data.item.menu" class="chip chip-category">
                        {{ data.item.menu.name }}
                      </span>
                    </template> -->
                    <template v-slot:cell(createdAt)="data">
                      <span
                        v-if="data.item.createdAtShow"
                        :class="
                          data.item.isPublish
                            ? 'chip chip-publish-success'
                            : 'chip chip-publish-danger'
                        "
                      >
                        {{ formatDate(data.item.createdAtShow) }}
                      </span>
                    </template>
                    <template v-slot:cell(isPublish)="data">
                      <ButtonCore
                        :text="data.item.isPublish ? 'Bỏ duyệt' : 'Duyệt'"
                        :variantClass="
                          data.item.isPublish
                            ? 'btn-deleteOutline-core'
                            : 'btn-accept-core'
                        "
                        :handleClick="
                          () =>
                            handleApproveTinTuc(
                              data.item,
                              !data.item.isPublish == false
                            )
                        "
                        :customStyle="{
                          width: '100px',
                          height: '30px',
                          fontSize: '12px',
                        }"
                      />
                    </template>
                    <template v-slot:cell(process)="data">
                      <ActionButtons
                        :item="data.item"
                        :actions="actionDefinitions"
                        @delete="handleShowDeleteModal"
                        @view="openPreview"
                      />
                    </template>
                  </b-table>
                </div>

                <!-- Modal preview news -->

                <div class="row">
                  <b-col>
                    <div>
                      Hiển thị {{ numberOfElement }} trên tổng số
                      {{ totalRows }} dòng
                    </div>
                  </b-col>
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-modal
              v-model="showPreview"
              centered
              size="xl"
              id="view-full-content"
              title="Xem trước bài đăng"
              no-close-on-backdrop
              modal-class="flower-modal"
              title-class="flower-title"
            >
              <ModalPreviewTinTuc
                v-if="showPreview"
                :data="tinTucSelected"
                @close="showPreview = false"
                @approve="
                  handleApproveTinTuc(
                    this.listApprove,
                    tinTucSelected.isPublish
                  )
                "
              />
              <template #modal-footer>
                <!-- Nút Tin trước -->
                <ButtonCore
                    text="Tin trước"
                    variantClass="btn-outline-info-core"
                    iconClass="fas fa-chevron-left"
                    :handleClick="previousPost"
                    :isDisable="isPreviousDisabled"
                    :isIconAfterText="false"
                    :customStyle="{ width: '110px' }"
                />
                <ButtonCore
                    text="Tin sau"
                    variantClass="btn-outline-info-core"
                    iconClass="fas fa-chevron-right"
                    :handleClick="nextPost"
                    :isDisable="isNextDisabled"
                    :isIconAfterText="true"
                    :customStyle="{ width: '110px' }"
                />
                <!-- Đóng -->
                <ButtonCore
                  text="Đóng"
                  variantClass="btn-close-core"
                  :handleClick="() => (showPreview = false)"
                  modalTarget="modal-close_visit"
                  :customStyle="{ width: '90px', margin: '4px' }"
                />

                <!-- Duyệt/Bỏ duyệt từ Modal Preview -->
                <!-- SỬA LỖI: SỬ DỤNG HÀM MŨI TÊN VÀ TRUYỀN ĐỐI TƯỢNG ĐƠN LẺ -->
                <ButtonCore
                  :text="tinTucSelected.isPublish ? 'Bỏ duyệt' : 'Duyệt'"
                  :variantClass="
                    tinTucSelected.isPublish
                      ? 'btn-deleteOutline-core'
                      : 'btn-accept-core'
                  "
                  :handleClick="
                    () =>
                      handleApproveTinTuc(
                        tinTucSelected,
                        !tinTucSelected.isPublish == false
                      )
                  "
                  :customStyle="{
                    width: '100px',
                    // height: '30px',
                    fontSize: '12px',
                  }"
                />

              </template>
            </b-modal>
<!--            Modal Xuất bản-->
            <b-modal
              v-model="showModalApproveAll"
              centered
              title="Xuất bản tất cả tin"
              title-class="font-18"
              no-close-on-backdrop
            >
              <p>Các bài đăng đã chọn sẽ được xuất bản!</p>
              <template #modal-footer>
                <!-- Đóng -->
                <ButtonCore
                  text="Đóng"
                  variantClass="btn-close-core"
                  :handleClick="() => (showModalApproveAll = false)"
                  modalTarget="modal-close_visit"
                  :customStyle="{ width: '90px', margin: '0 5px' }"
                />

                <!-- Xuất bản hàng loạt -->
                <!-- SỬA LỖI: SỬ DỤNG HÀM MŨI TÊN VÀ TRUYỀN NULL ĐỂ KÍCH HOẠT HÀNH ĐỘNG HÀNG LOẠT -->
                <ButtonCore
                  text="Xuất bản"
                  variantClass="btn-success-core"
                  iconClass="fas fa-upload"
                  :handleClick="
                    () => {
                      handleApproveTinTuc(null, false);
                    }
                  "
                  :customStyle="{ width: '130px' }"
                />
              </template>
            </b-modal>

<!--            Modal xoá-->
            <b-modal
              v-model="showDeleteModal"
              centered
              title="Xóa dữ liệu"
              title-class="font-18"
              no-close-on-backdrop
            >
              <p>Dữ liệu xóa sẽ không được phục hồi!</p>
              <template #modal-footer>
                <!-- <button
                  v-b-modal.modal-close_visit
                  class="btn btn-outline-info m-1"
                  v-on:click="showDeleteModal = false"
                >
                  Đóng
                </button>
                <button
                  v-b-modal.modal-close_visit
                  class="btn btn-danger btn m-1"
                  v-on:click="handleDelete"
                >
                  Xóa
                </button> -->

                <ButtonCore
                  text="Đóng"
                  variantClass="btn-close-core"
                  :handleClick="() => (showDeleteModal = false)"
                  modalTarget="modal-close_visit"
                  :customStyle="{ width: '90px', margin: '4px' }"
                />

                <ButtonCore
                  text=" Xóa"
                  variantClass="btn-danger-core"
                  iconClass="fas fa-trash"
                  :handleClick="handleDelete"
                  modalTarget="modal-close_visit"
                  :customStyle="{ width: '100px' }"
                />
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.td-stt {
  text-align: center;
}
.td-xuly {
  text-align: center;
  width: 10% !important;
}

.td-chuyenmuc {
  width: 20%;
}
.td-trangthai {
  width: 10%;
}
.vue-treeselect__control {
  height: 39px !important;
}

/* 1. Style chung cho tất cả các nút hành động (bao gồm cả hàng loạt và đơn lẻ) */
.news-btn-action-custom {
  padding: 6px 10px;
  font-size: 0.85rem;
  font-weight: 500;
  border-radius: 8px; /* Bo tròn hơn một chút cho hiện đại */
  margin: 3px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.2s ease-in-out;
  border: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Đổ bóng nhẹ */
  min-width: 70px;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
}

.news-btn-action-custom:hover {
  opacity: 0.9;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}


/* 4. Style cho nút "Xuất bản tất cả" (Màu xanh dương đậm) */
.news-btn-publish-all {
  background-color: #007bff; /* Màu xanh dương */
  color: #ffffff;
  font-size: 0.9rem;
  padding: 8px 15px;
  min-width: 140px; /* Độ rộng lớn hơn */
}

/* 5. Style cho badge số lượng đã chọn */
.news-badge-count {
  background-color: #007bff;
  color: #ffffff;
  font-size: 0.85rem;
  padding: 8px 12px;
  border-radius: 8px; /* Bo tròn đồng bộ với nút */
  margin-right: 15px;
  font-weight: 500;
}
.news-publish-switch .custom-control-label::before {
  /* Tùy chỉnh màu nền cho switch khi TẮT (Chưa xuất bản) */
  background-color: #dc3545; /* Màu đỏ khi TẮT (Chưa xuất bản) */
  border-color: #dc3545;
}
.news-publish-switch input:checked ~ .custom-control-label::before {
  background-color: #28a745 !important; /* Màu xanh lá khi BẬT (Xuất bản) */
  border-color: #28a745 !important;
}
.news-publish-switch .custom-control-label {
  /* Đảm bảo nhãn text nằm bên cạnh switch */
  display: flex;
  align-items: center;
  /* Tăng khoảng cách giữa switch và nhãn */
  padding-left: 2.5rem;
}
.news-publish-switch .custom-control-label::after {
  /* Đặt knob/núm vặn màu trắng */
  background-color: #fff;
}
::v-deep .modal-header {
  background: linear-gradient(
      135deg,
      var(--color-primary-dark),
      var(--color-primary)
  ); /* Gradient xanh tươi */
  color: white;
  border-bottom: none;
  padding: 1rem 1.5rem;
}

::v-deep .flower-title {
  font-weight: 700;
  font-size: 1.3rem;
  color: var(--color-white);
}
</style>
